import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../core/auth.service';
import { MESSAGE_UNAUTHORIZED_ACCESS } from '../shared/lecture-message';
import { LectureUserService } from '../shared/lecture-user.service';

@Injectable()
export class LectureAuthGuard implements CanActivate {

  constructor(private snackBar: MatSnackBar,
    private service: LectureUserService,
    private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.service.readEnrollment({ $key: route.parent.parent.params['id'] }).map(enrollment => {
      // if (enrollment && enrollment.state) {
      //   return true;
      // }
      //
      // if (this.authService.isContentManager) {
      //   return true;
      // }

      return true;

      // this.openSnackBar(MESSAGE_UNAUTHORIZED_ACCESS);
      // return false;
    });
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
  //   if (!this.auth.isAuthenticated) {
  //     return Observable.of(false);
  //   }

  //   let $this = this;

  //   return Observable.create(observer => {
  //     this.http.get(`${this.env.apiBaseUrl()}${state.url}`)
  //       .then(response => {
  //         response.subscribe(
  //           data => {
  //             observer.next(true);
  //           }, err => {
  //             $this.openSnackBar(MESSAGE_UNAUTHORIZED_ACCESS);
  //             observer.next(false);
  //           }
  //         )
  //       })
  //     });
  // }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture-auth.guard.ts